import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { FormFieldGroup } from '@models/forms/form-field-group.model';
import { get } from 'lodash';

@Directive({
  selector: '[sizeForm]',
})
export class SizeDirective implements OnInit {
  @Input() group: FormFieldGroup;
  colSize: number | null;
  constructor(private eleRef: ElementRef) {}

  ngOnInit() {
    this.colSize = get(this.group, 'questions[0].colSize', null);
    if (this.colSize != null) {
      const colSize =
        this.group.name === 'likes dislikes' ||
        this.group.name === 'diet allergies' ||
        this.group.name === 'other details'
          ? 12
          : this.colSize;
      this.eleRef.nativeElement.parentNode.classList.add('col-' + colSize);
    }
  }
}
